import React, {useEffect, useState} from "react";
import Spinner from "../../../../spinner";
import {Button, Col, Table, Row, notification} from "antd";
import {tableHelper} from "../../../../../helpers";
import {useFetchNotification} from "../../../../../hooks/use-fetch-notification";
import NotificationMessage from "../../../../modals/notification-message";
import {userServices} from "../../../../../services";
import {COMPANY_DIRECTOR_PERMISSION} from "../../../../../helpers/user_permission.helper";
import ModalLoginApiCompany from "../../../../modals/epd-astral/login-api-company";
import ModalAttorneyApiCompany from "../../../../modals/epd-astral/attorney-api-company";
import {Link, Route, Redirect} from "react-router-dom";
import DividerBlock from "../../../../divider-block";
import { edoService } from "../../../../../services/edo.services";
import ModalEdoAuth from "../../../../modals/edo-auth";
import { accountStatuses } from "../../../../../helpers/edo.helper";
import { render } from "react-dom/cjs/react-dom.development";

export default function EdoLegalEntities() {
  const [loading, setLoading] = useState(false);
  const [isNeedUpdateEntities, setIsNeedUpdateEntities] = useState(false);
  const [isNeedTypesList, setIsNeedTypesList] = useState(true);
  const [isNeedGetAccount, setIsNeedGetAccount] = useState(false);
  const [stopListUpdate, setStopListUpdate] = useState(false);
  const [isModalRegisterApiCompanyShow, setIsModalRegisterApiCompanyShow] = useState(false);
  const [isModalAttorneyShow, setIsModalAttorneyShow] = useState(false);
  const [needAuth, setNeedAuth] = useState(false);
  const [typesList, setTypesList] = useState(null);

  const [errorMsg, setErrorMsg] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [entitiesData, setEntitiesData] = useState(null);
  const [leId, setLeId] = useState(null);
  const [leName, setLeName] = useState(null);
  const [action, setAction] = useState(null);
  const [showLogin, setShowLogin] = useState(false);

  const [{notifications}] = useFetchNotification(true);

  const [certificate, setCertificate] = useState(null);
  const [edoAccounts, setEdoAccounts] = useState(false);
  const [accountsData, setAccountsData] = useState([]);
  const [currentType, setCurrentType] = useState(null);

  const user = userServices.getUser();

  let bigButtonStyle = {
    width: '190px',
    height: '40px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    float: 'right',
    borderColor: "#1CAA53"
  };

  useEffect(() => {
    if (loading === false && stopListUpdate !== true) {
    }
  }, [isNeedGetAccount, stopListUpdate]);

  useEffect(() => {
    if (!typesList && isNeedTypesList) {
      setLoading(true);
      edoService.getTypes()
        .then((res) => {
          setTypesList(res);
          setIsNeedTypesList(false);
          setIsNeedGetAccount(true);
        })
        .catch((error) => {
          notification.error({
            message: "Получение данных о типах ЭДО", description: error,
          });
        });
    }
  }, [isNeedTypesList]);

  useEffect(() => {
    if(isNeedGetAccount) {
      edoService
        .getAccounts()
        .then((response) => {
          if(response.status && response.status === 'error') {
            notification.error({message: "Авторизация", description: response.message});
            setEdoAccounts([]);
          } else {
            if(!response.hasValid) {
              //setNeedAuth(true);
            }
            setEdoAccounts(response.data);
            let newAccData = [];
            typesList.map((type) => {
              let accData = {
                'alias': type.Id,
                'type': type.Name,
                'username': '-',
                'status': 'unknown',
              };
              if(type.Id in response.data) {
                accData.username = response.data[type.Id]['userName'];
                accData.status = response.data[type.Id]['isValid'] ? 'valid' : 'invalid';
              }

              newAccData.push(accData);
            });

            setAccountsData(newAccData);

          }
          setIsNeedGetAccount(false);
          setIsNeedUpdateEntities(true);
          setLoading(false);
        })
        .catch((errorMsg) => {
          setIsNeedGetAccount(false);
          setErrorMsg(errorMsg);
          setLoading(false);
        });
    }
  }, [isNeedGetAccount]);

  useEffect(() => {
    if (isNeedUpdateEntities) {
      setLoading(true);
      edoService
        .getCompanies()
        .then((response) => {
          let reindexedTableData = [];
          response.forEach((item) => {
            reindexedTableData.push({
              name: item.Name,
              orgForm: item.OrgForm,
              orgFormId: item.OrgFormId,
              id: item.Id,
              confirmation: item.VitalAgreed ? 'Да' : 'Нет',
              permissions: item.Permissions,
              tax: (item.Tax ? item.Tax.fullTitle : ''),
              countryId: item.CountryId,
              EdoCompanies: item.EdoCompanies,
            });
          });

          setEntitiesData(reindexedTableData);
          setIsNeedUpdateEntities(false);
          setLoading(false);
        })
        .catch((errorMsg) => {
          setIsNeedUpdateEntities(false);
          setErrorMsg(errorMsg);
          setLoading(false);
        });
    }
  }, [isNeedUpdateEntities]);

  useEffect(() => {
    if(needAuth) {
      setShowLogin(true);
    }
  }, [needAuth]);


  if (errorMsg) {
    return <div className="content-error-block">{errorMsg}</div>;
  }

  const accountColumns = [
    {
      title: "Тип",
      dataIndex: "type",
    },
    {
      title: "Пользователь",
      dataIndex: "username",
    },
    {
      title: "Статус",
      dataIndex: "status",
      render: (record) => {
        return <div>{accountStatuses[record]}</div>;
      }
    },
    {
      title: "Действия",
      key: "actions",
        render: (data) => {
          return (
            <React.Fragment>
              <Button
                type="primary"
                icon="plus"
                style={{width: '100%'}}
                key={`${user}-plus`}
                onClick={() => {
                    setShowLogin(true);
                    setCurrentType(data.alias);
                  }
                }
              >
                {data.status === 'valid' ? 'Редактировать' : 'Авторизоваться'}
              </Button>
            </React.Fragment>
          );
        }
    }
  ];

  const columns = [
    {
      title: "Название",
      dataIndex: "name",
      width: "25%",
      ...tableHelper.getColumnSearchProps("name", searchText, setSearchText),
    },
    {
      title: "Орг. форма",
      dataIndex: "orgForm",
      width: "10%",
    },
    {
      title: "Абонент ЭДО",
      render: (record) => {
        return record.EdoCompanies.map((edoCompany) => {
          return <div>{edoCompany.type} ({edoCompany.abonent_id})</div>;
        });
      },
      width: "35%",
    }
  ];


  if (!user.isAccessTo(COMPANY_DIRECTOR_PERMISSION)) {
    return <Redirect to="/company/car-park"/>;
  }

  return (
    <React.Fragment>
      <NotificationMessage
        notifications={notifications}
        setStopListUpdate={setStopListUpdate}
        loading={false}
      />
      <Spinner loading={loading} tip="Загрузка...">
      <Row>
        <Col span={24}>
            <Table
              style={{minWidth: "700px"}}
              columns={accountColumns}
              dataSource={accountsData}
              locale={{emptyText: "Данные отсутствуют"}}
              rowKey="id"
              size="small"
              pagination={{
                pageSize: 50,
              }}
              className="car-park"
              rowClassName={(record, index) => "car-park-row"}
            />
        </Col>
      </Row>
      <Row>
        <Col
          className={"content-header"}
          style={{marginBottom: "0px"}}
          span={12}
        >
          Абоненты ЭДО
        </Col>
      </Row>
      <Row>
        <Col span={24}>
            <Table
              style={{minWidth: "700px"}}
              columns={columns}
              dataSource={entitiesData}
              locale={{emptyText: "Данные отсутствуют"}}
              rowKey="id"
              size="small"
              pagination={{
                pageSize: 50,
              }}
              className="car-park"
              rowClassName={(record, index) => "car-park-row"}
            />
        </Col>
      </Row>
      </Spinner>
      <ModalEdoAuth type={currentType} isShow={showLogin} setIsShow={setShowLogin} setIsNeedUpdate={setIsNeedGetAccount}/>
    </React.Fragment>
  );
}
